import { all, put, select, takeLatest } from 'redux-saga/effects';
import { PLAN_LOADED, PLAN_SAVED } from 'domain/Options/constants';
import { planSelector, planNameSelector } from 'domain/Options/selectors';
import { applicationModeSelector } from 'Application/selectors';
import { KIOSK, NORMAL } from 'Application/constants';
import { addSavedPlan } from './actions';
import { save } from './utils';
import { savedPlansSelector, lastVersionSelector, hasSeenNewFeaturesSelector, hasLoadedOldPlanSelector, hasClosedProductMessageSelector } from './selectors';
import { applicationSettingsSelector, localeSelector } from 'domain/LanguageProvider/selectors';
import {
  CookieConsentService
} from "@inter-ikea-kompis/services";

import {
  SAVED_PLANS_LOCALSTORAGE_KEY,
  REMOVE_SAVED_PLAN,
  UPDATE_SAVED_PLAN_NAME,
  ADD_SAVED_PLAN,
  CHECKED_SAVED_PLAN,
  SET_LAST_VERSION,
  LAST_VERSION_LOCALSTORAGE_KEY,
  SET_HAS_SEEN_NEW_FEATURES,
  HAS_SEEN_NEW_FEATURES_LOCALSTORAGE_KEY,
  SET_HAS_LOADED_OLD_PLAN,
  HAS_LOADED_OLD_PLAN_LOCALSTORAGE_KEY,
  CLOSE_PRODUCT_MESSAGE,
} from './constants';

const getNow = () => {
  return Date.now();
};

export function* planSavedOrLoaded(action) {
  const applicationMode = yield select(applicationModeSelector);
  const savedPlan = yield select(planSelector);
  const name = yield select(planNameSelector);
  const urlContainsAddon = window.location.href.includes('addon-app') && !window.location.href.includes('cte');
  const useCookie = (applicationMode === NORMAL) && urlContainsAddon;
  if (!useCookie) {
    if (action.code) {
      yield put(addSavedPlan(action.code, savedPlan.getIn(['expression', 'value', 'displayImage']), name, action.updateLastOpened, getNow()));
    }
  }

  if (useCookie) {
    const applicationSettings = yield select(applicationSettingsSelector);
    const locale = yield select(localeSelector);
    const cookieLocale = `${locale["language"]}-${(locale["country"]).toUpperCase()}`;
    const hasConsent = yield new CookieConsentService({
      locale: cookieLocale,
      settings: applicationSettings
    }
    ).hasCookieConsent(2);

    if (hasConsent) {
      console.log("Consent is: ", hasConsent, "localstorage used with action: ", action);
      if (action.code) {
        console.log("Localstorage - adding saved plan to Localstorage");
        yield put(addSavedPlan(action.code, savedPlan.getIn(['expression', 'value', 'displayImage']), name, action.updateLastOpened, getNow()));
      }
    } else {
      console.log("Consent is: ", hasConsent, "localstorage not used with action: ", action);
    }
  }
}

function* saver(key, selector) {
  const value = yield select(selector);
  save(key, value);
}

function* saveToLocalStorage(action) {
  switch (action.type) {
    case REMOVE_SAVED_PLAN:
    case UPDATE_SAVED_PLAN_NAME:
    case ADD_SAVED_PLAN:
    case CHECKED_SAVED_PLAN:
      yield saver(SAVED_PLANS_LOCALSTORAGE_KEY, savedPlansSelector);
      break;
    case SET_LAST_VERSION:
      yield saver(LAST_VERSION_LOCALSTORAGE_KEY, lastVersionSelector);
      break;
    case SET_HAS_SEEN_NEW_FEATURES:
      yield saver(HAS_SEEN_NEW_FEATURES_LOCALSTORAGE_KEY, hasSeenNewFeaturesSelector);
      break;
    case SET_HAS_LOADED_OLD_PLAN:
      yield saver(HAS_LOADED_OLD_PLAN_LOCALSTORAGE_KEY, hasLoadedOldPlanSelector);
      break;
    case CLOSE_PRODUCT_MESSAGE:
      yield saver(CLOSE_PRODUCT_MESSAGE, hasClosedProductMessageSelector);
      break;
    default:
      break;
  }
}

function* localStorageSagas() {
  yield all([
    takeLatest([PLAN_LOADED, PLAN_SAVED], planSavedOrLoaded),
    takeLatest([
      REMOVE_SAVED_PLAN,
      UPDATE_SAVED_PLAN_NAME,
      ADD_SAVED_PLAN,
      CHECKED_SAVED_PLAN,
      SET_LAST_VERSION,
      SET_HAS_SEEN_NEW_FEATURES,
      SET_HAS_LOADED_OLD_PLAN,
      CLOSE_PRODUCT_MESSAGE,
    ], saveToLocalStorage),
  ]);
}

// All sagas to be loaded
export default localStorageSagas;
